import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IObjectDto } from '@fi-shared/models/models';
import { ObjectTypes } from '@fi-shared/types';
import { ILightWeightArea, ILocalSearchDataItemModel } from '@fi-shared/models';

@Component({
    selector: 'data-field-view-areas',
    templateUrl: './areas.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewAreasComponent extends FiDataFieldViewBase {
    getAreas(): ILightWeightArea[] {
        if (this.dataFieldObject.Area) return [this.dataFieldObject.Area];
        if (this.dataFieldObject.Areas) return this.dataFieldObject.Areas;
        return [];
    }

    // note: not used ?
    FiStateNames = FiStateNames;
    get isNotEmpty() {
        return true;
    }

    getSearchObjects(area: ILightWeightArea): [ILocalSearchDataItemModel] {
        return [
            {
                Id: area.Id,
                ObjectType: ObjectTypes.Area,
                Name: area.Name,
            },
        ];
    }
}
